import { ReactNode, useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "app/hooks";
import { LoadingSpinner } from "react/components/LoadingSpinner";
import { NotAuthorized } from "routes/NotAuthorized";
import {
    fetchUserWithPermissions,
    selectIsAuthenticated,
    selectStatus,
} from "./currentUserSlice";
import { Client } from "@genesys/cloud-frontend/dist/mjs/client";
import {
    fetchToggles,
    selectFeatureTogglesLoaded,
} from "features/featureToggles/featureToggleSlice";
import config from "config";

export function RequireAuth({ children }: { children: ReactNode }) {
    const dispatch = useAppDispatch();
    const userStatus = useAppSelector(selectStatus);
    const featureTogglesLoaded = useAppSelector(selectFeatureTogglesLoaded);
    const [clientInitialized, setClientInitialized] = useState(false);
    useEffect(() => {
        const initialize = async () => {
            try {
                await Client.getClient(config.appName);
            } catch (error) {
                console.log(error);
            } finally {
                setClientInitialized(true);
            }
        };
        initialize();
    }, [dispatch]);

    useEffect(() => {
        if (!clientInitialized) return;
        if (userStatus === "idle") {
            dispatch(fetchUserWithPermissions());
        }
    }, [dispatch, userStatus, clientInitialized]);

    useEffect(() => {
        if (!clientInitialized) return;
        if (!featureTogglesLoaded) {
            dispatch(fetchToggles());
        }
    }, [dispatch, featureTogglesLoaded, clientInitialized]);

    const isAuthenticated = useAppSelector(selectIsAuthenticated);

    const settled =
        (userStatus === "finished" || userStatus === "failed") &&
        featureTogglesLoaded;
    return (
        <>
            {!settled && <LoadingSpinner />}
            {settled && (isAuthenticated ? children : <NotAuthorized />)}
        </>
    );
}
